var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "authWrapper new-login-wrapper recover-email-wrapper"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row login-white-wrap whiteBG-wrap login-margin"
  }, [_c('div', {
    staticClass: "col-lg-7 col-md-7 no-padding"
  }, [_c('div', {
    staticClass: "login-left-wrap"
  }, [_c('div', {
    staticClass: "email-login-form",
    attrs: {
      "role": "main",
      "aria-labelledby": "recover-email-title"
    }
  }, [_vm._m(0), _c('h4', {
    staticClass: "login-title mb-3",
    attrs: {
      "id": "recover-email-title"
    }
  }, [_vm._v("Email Recovered Successfully")]), _c('div', {
    staticClass: "auth-form pt-1 pb-3"
  }, [_c('div', {
    staticClass: "verification-detail p-0 text-center"
  }, [_c('div', {
    staticClass: "recovered-email-section",
    attrs: {
      "role": "status",
      "aria-live": "polite",
      "aria-label": 'Recovered email: ' + _vm.email,
      "aria-describedby": 'recover-email-desc'
    }
  }, [_c('div', {
    staticClass: "recovery-info mb-2"
  }, [_vm._m(1), _c('div', {
    staticClass: "recovered-email-info text-left"
  }, [_c('p', {
    staticClass: "recovered-label"
  }, [_vm._v("Your recovered email address:")]), _c('h2', {
    staticClass: "recovered-email mb-2",
    attrs: {
      "aria-label": 'Email address: ' + _vm.email
    }
  }, [_vm._v(" " + _vm._s(_vm.email) + " ")])])]), _c('p', {
    staticClass: "sub-head text-left mb-0",
    attrs: {
      "id": "recover-email-desc"
    }
  }, [_vm._v(" We've successfully recovered your login email address. You can now proceed to log in. ")])])]), _c('div', {
    staticClass: "action-btn flex-column gap-2"
  }, [_c('button', {
    staticClass: "submit-btn next-btn m-0",
    attrs: {
      "type": "button",
      "aria-label": "Go to login page"
    },
    on: {
      "click": _vm.loginLink
    }
  }, [_vm._v(" Continue to Login ")]), _c('div', {
    staticClass: "additional-actions"
  }, [_c('router-link', {
    staticClass: "login-highlight",
    attrs: {
      "to": {
        name: 'ForgotEmail'
      },
      "aria-label": "Recover another email"
    }
  }, [_vm._v(" Recover another email? ")])], 1)])])])])]), _c('div', {
    staticClass: "col-lg-5 col-md-5 no-padding p-0"
  }, [_c('LoginCarsoule')], 1)])])]);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "left-login"
  }, [_c('div', {
    staticClass: "rep-icon-login"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/dashboard-rep.svg"),
      "alt": "Dashboard representative icon",
      "aria-hidden": "true"
    }
  })]), _c('div')]);
},function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "verification-icon",
    attrs: {
      "role": "img",
      "aria-label": "Success checkmark"
    }
  }, [_c('img', {
    staticClass: "img-fluid",
    attrs: {
      "src": require("@/assets/images/ph-seal-check.svg"),
      "alt": "Success verification icon"
    }
  })]);
}]

export { render, staticRenderFns }